import templateUrl from "emun.cust/cust-container.htm";
import controller from "emun.cust/cust-container.controller";

export default {
  bindings: {
    ngModel: "=?",
    retailerId: "@",
    customerId: "@",
    filters: "<?",
    views: "<?",
    templates: "<?",
    canManage: "<?",
    realm: "@",
    shard: "@",
    hideHeader: "<?",
    hideFooter: "<?",
    layout: "@",
    disableQueryString: "<",
    mode: "@",
    accept: "@",
    icon: "@",
    size: "@",
    tags: "<?",
    criteria: "<?",
    tagCriteria: "<?",
    onSelect: "&",
    onAdd: "&",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
